(ns common.schema.entities.counterparty-diligence.templates.questions.board-member)

(def role
  {:field     :board-member/role
   :label     {:en "Role"}
   :data-type :data.type/keyword
   :options   [{:key          :board-member
                :value        :board-member
                :label        {:en "Board member"
                               :fi "Hallituksen jäsen"}}
               {:key          :chair-of-the-board
                :value        :chair-of-the-board
                :label        {:en "Chair of the board"
                               :fi "Hallituksen puheenjohtaja"}}
               {:key          :deputy-board-member
                :value        :deputy-board-member
                :label        {:en "Deputy board member"
                               :fi "Hallituksen varajäsen"}}]})
